import expert1 from "../illustrations/expert1.svg";
import expert2 from "../illustrations/expert2.svg";
import student1 from "../illustrations/student1.svg";
import student2 from "../illustrations/student2.svg";
import student3 from "../illustrations/student3.svg";
import student4 from "../illustrations/student4.svg";
import student5 from "../illustrations/student5.svg";
import student6 from "../illustrations/student6.svg";
import student7 from "../illustrations/student7.svg";
import student8 from "../illustrations/student8.svg";
import teacher1 from "../illustrations/teacher1.svg";
import teacher2 from "../illustrations/teacher2.svg";

export const illustrations = {
  Lehrperson: [teacher1, teacher2],
  "Beobachter*in": [expert1, expert2],
  "Schüler*in": [
    student1,
    student2,
    student3,
    student4,
    student5,
    student6,
    student7,
    student8,
  ],
};
